// Enthält Methoden um den UserAgent zu analysieren 

interface IUserAgent {
    isApp : boolean;
    isIOS : boolean;
    isAndroid : boolean; 
    isARAble?: boolean; 
}

export let userAgent: IUserAgent = {
    isAndroid: false,
    isApp : false,
    isIOS: false,
    isARAble: false,
};

export function readUserAgent(): string {
  const ua: string = "" + navigator.userAgent;
  const start: number = ua.indexOf("[");
  const end: number = ua.indexOf("]");
  const length: number = end - start;

  let uaArr: string[];
  uaArr = ua.substr(start, length).split(";");

  userAgent.isApp = uaArr.some(checkApp);
  userAgent.isAndroid = uaArr.some(checkAndroid);
  userAgent.isIOS = uaArr.some(checkIOS);
  userAgent.isARAble = uaArr.some(checkARAble);
  return ua;
}

function checkApp(ua: string): boolean {
  return ua.toLowerCase().includes("app=true");
}

function checkIOS(ua: string): boolean {
  return ua.toLowerCase().includes("apptype=ios");
}

function checkAndroid(ua: string): boolean {
  return ua.toLowerCase().includes("apptype=android");
}

function checkARAble(ua: string): boolean {
  return (
    ua.toLowerCase().includes("renderlib=scenekit") ||
    ua.toLowerCase().includes("renderlib=sceneform")
  );
}


// WEBPACK FOOTER //
// ./src/functions/analyseUserAgent.ts